import { prefixes, prependIntlIds } from "../utils";

const adminPrepend = "🛠️";

export const unprefixedPageTitleMessages = {
  login: "Log in",
  reset_password: "Reset password",
  registration: "Registration",

  hwr: "HWR",
  overview: "📋 {templateName}",
  detail: "🔎 {templateName}",
  edit: "🖊 {templateName}",

  homepage: "Home",
  settings: "Settings",

  template_builder: "🏗️ {templateName}",
  administration: adminPrepend,

  "administration.data_sources": `${adminPrepend} data sources`,
  "administration.functions": `${adminPrepend} functions`,
  "administration.information": `${adminPrepend} information`,
  "administration.modules": `${adminPrepend} modules`,
  "administration.personalization": `${adminPrepend} personalization`,
  "administration.roles": `${adminPrepend} roles`,
  "administration.tables": `${adminPrepend} tables`,
  "administration.templates": `${adminPrepend} templates`,
  "administration.users": `${adminPrepend} users`,
} as const;

const ids = prependIntlIds(prefixes.pageTitle, unprefixedPageTitleMessages);

export default prependIntlIds(prefixes.pageTitle, unprefixedPageTitleMessages);
